import * as React from 'react';
import { Show, ShowProps, SimpleShowLayout, TextField } from 'react-admin';
import { TranslateField } from '../components/TranslateField';

export const CoachGuideCategoryShow = (props: ShowProps): React.ReactElement => {
	return (
		<Show {...props}>
			<SimpleShowLayout>
				<TextField source="id" label="#"/>
				<TextField source="name" label="NAME"/>
				<TranslateField source="language" label="LANGUAGE"/>
			</SimpleShowLayout>
		</Show>
	);
};
